import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { posServices,posVersions } from "../../Services";
import { useEffect } from "react";

const AddVersionToAllPos = ({ setShowAddToAllPos, showAddToAllPos }) => {
  const { t: translator } = useTranslation();
  const { register } = useForm();
  const [posVersions, setPosVersions] = useState();
  const [selectedVersion, setSelectedVersion] = useState();
  const [currentVersion, setCurrentVersion] = useState(false);
  const handleAddVersion = () => {
    alert(selectedVersion);
    return;
    //poziv na backend-> selectedVersion
    posVersions.AddVersionToAllPos(Number(selectedVersion))
    .then((data) => {
       
         setShowAddToAllPos(false);
    setSelectedVersion(0);
      })
      ;
   
  };
  const handleSelectChange = (e) => {
    setSelectedVersion(e.target.value);

  };
  useEffect(() => {
    posServices.getPosVersions().then((res) => {
      
      setPosVersions(res?.data);
    });
  }, []);
  return (
    <div>
      <Modal show={showAddToAllPos} centered onHide={setShowAddToAllPos}>
        <Modal.Header>
         <Modal.Title>{translator("ManagingVersion-AddVersion-All")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>{translator("Administration-PosVersion-Name")}</label>
          <select
            ref={register({ required: true })}
            className="form-control"
            name="posVersionId"
            onChange={(e)=> {console.log(e.target.value); setSelectedVersion(e.target.value);}}
           
          >
            <option value="0">{translator("Select-Version")}</option>
            {posVersions?.map((posVer) => (
              <option key={posVer?.id} value={posVer.id}>
                {translator(posVer?.name)}
              </option>
            ))}
          </select>
        </Modal.Body>
        <Modal.Footer>
          {" "}
          <button
            onClick={() => setShowAddToAllPos(false)}
            //className="secondaryFileButton"
            className="btn btn-outline-secondary"
          >
            {translator("Btn-Cancel")}
          </button>
          <button
            appearance="primary"
            onClick={handleAddVersion}
            className="btn btn-primary"
            //disabled={currentVersion}
          >
            {translator("Btn-Save")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddVersionToAllPos;
